import React, { useState, useEffect, useRef } from 'react';
// import "./../../../InvoiceDetail.css";
import Cookies from 'js-cookie';
import axios from 'axios';
import { useParams, useLocation } from 'react-router-dom';
import { use } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
// import PaymentService from "../../components/Service/NeoXService";
import PaymentService from '../../../components/Service/NeoXService';
import { useNavigate } from "react-router-dom";
import { createPayPal } from '../../../components/Service/PaypalService';
import { updateWallet } from "../../../components/Service/Transaction";
import useLanguage from '../../../Hooks/useLanguage';
import { useTranslation } from 'react-i18next';
//eslint-disable-next-line
import html2pdf from "html2pdf.js";

const InvoiceDetailCSHP = () => {
    const baseURL = process.env.REACT_APP_API_URL;

    const navi = useNavigate();
    const [invoiceData, setInvoiceData] = useState(null);
    const { invoiceId } = useParams();

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const initialMonth = queryParams.get("month") || (new Date().getMonth() + 1);

    const currentYear = new Date().getFullYear();
    const [filterType, setFilterType] = useState(initialMonth);
    const [year, setYear] = useState(currentYear);
    useLanguage();

    const { t } = useTranslation();
    console.log("year", year)
    console.log("filterType", filterType)



    const yearOptions = [];
    for (let i = currentYear - 3; i <= currentYear + 3; i++) {
        yearOptions.push(i);
    }
    const handleYearChange = (event) => {
        const selectedYear = event.target.value;
        setYear(selectedYear);
        updateURL(selectedYear, filterType);

    };

    const handleFilterChange = (event) => {
        const selectedMonth = event.target.value;
        setFilterType(selectedMonth);

        const selectedYear = year;
        const startDate = new Date(selectedYear, selectedMonth, 1);
        const endDate = new Date(selectedYear, selectedMonth, 0);

        const startDateString = startDate.toISOString().split('T')[0];
        const endDateString = endDate.toISOString().split('T')[0];

        setStartDate(startDateString);
        setEndDate(endDateString);

        updateURL(selectedYear, selectedMonth);
    };


    const updateURL = (selectedYear, selectedMonth) => {
        navi(`/cshp/invoice-detail/${invoiceId}?month=${selectedMonth}&year=${selectedYear}`);
    };

    const [user, setuser] = useState(null);
    const [orderDetails, setorderDetails] = useState(null);
    const [InvoiceItem, setInvoiceItem] = useState(null);

    const summary = {
        subtotal: "140,000 đ",
        vat: "14,000 đ",
        total: "154,000 đ",
    };
    const fetchInvoiceData = async () => {
        try {
            setInvoiceItem([]);
            setInvoiceData(null);

            const token = Cookies.get("Token");
            const month = filterType;
            const selectedYear = year;

            const response = await axios.get(`${baseURL}/api/v1/cshp-invoice-detail/${invoiceId}`, {
                params: { month, year: selectedYear },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            console.log("response?.data", response?.data);
            setInvoiceData(response.data);
            setInvoiceItem(response.data?.invoice_items || []);
            setuser(response.data?.user);

            const startDate = new Date(selectedYear, month - 1, 1);
            const endDate = new Date(selectedYear, month, 0);
            startDate.setDate(startDate.getDate() + 1);
            endDate.setDate(endDate.getDate() + 1);

            const startDateString = startDate.toISOString().split('T')[0];
            const endDateString = endDate.toISOString().split('T')[0];

            setStartDate(startDateString);
            setEndDate(endDateString);
        } catch (err) {
            console.error('Lỗi khi tải dữ liệu hóa đơn:', err);
        }
    };
    useEffect(() => {
        if (year && filterType) {
            let start = new Date(year, filterType - 1, 1);
            let end = new Date(year, filterType, 0);
            start.setDate(start.getDate() + 1);
            setStartDate(start.toISOString().split('T')[0]);
            setEndDate(end.toISOString().split('T')[0]);

            fetchInvoiceData();
        }
    }, [filterType, year]);






    console.log("InvoiceItem", InvoiceItem)


    useEffect(() => {
        fetchInvoiceData();
    }, [filterType]);

    // const handleSelectedPay = async () => {
    //     const approvalUrl = await createPayPalOrder(invoiceId, invoiceData?.total);
    //     window.location.href = approvalUrl;

    // }

    const [isLoading, setIsLoading] = useState(false);
    // const isUpgrade = invoiceData?.items[0]?.notes?.includes("=>");
    // console.log("isUpgrade", isUpgrade)


    const invoiceRef = useRef();
    const handlePrintPDF = async () => {
        const element = invoiceRef.current;

        html2pdf()
            .from(element)
            .set({
                filename: 'invoice.pdf',
                html2canvas: { scale: 2 },
                jsPDF: { format: 'a4', orientation: 'portrait' },
                pagebreak: { mode: 'avoid-all' },
            })
            .toPdf()
            .get('pdf')
            .then((pdf) => {
                if (pdf.internal.getNumberOfPages() > 1) {
                    // pdf.deletePage(2);
                }
                pdf.save('invoice.pdf');
            });
    };
    const LoadingSpinner = () => (
        <div className="loading-overlay">
            <div className="spinner"></div>
        </div>
    );

    const [colorButton, setColorButton] = useState("green");
    const [textColor, setTextColor] = useState("white");
    const [isDisabled, setIsDisabled] = useState(false);

    const handleConfirmBank = () => {
        setColorButton("gray");
        setTextColor("white");
        setIsDisabled(true);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };


    const banks = [
        {
            name: 'Techcombank',
            branch: 'Chi nhánh Kỳ Hòa - TP Hồ Chí Minh',
            accountNumber: '63096868',
            accountName: 'CÔNG TY TNHH TIDADIGI',
            transferNote: `Thanh toan don hang ${invoiceData?.invoice_number}`,
            qrImage: 'https://cms.qrgateway.com/storage/posts/February2024/_0ff5b93f-baef-4f24-99a1-f110caf48aee.jpg' // Đường dẫn ảnh QR
        }
    ];


    const statusColors = {
        0: "#FFC107",
        1: "#28A745",
        2: "#6C757D",
        4: "#DC3545",
        5: "#17A2B8",
        6: "#FD7E14",
        7: "#FF5733"
    };

    return (
        <>
            <div className="body-content">

                <div className="px-2 py-2 mx-4 mb-4 justify-content-between">
                    <h2 style={{ color: "#0069ff" }} className="mb-0">{t("Invoice")} {invoiceData?.invoice?.invoice_number}</h2>
                    <div className='row' style={{ marginBottom: "10px" }}>
                        <div className="col-3 mb-4">
                            <a href="/invoice" className="btn-link my-5">
                                <small>{t("ViewIV")}</small>
                            </a>
                        </div>
                        <div className='col-7'>

                        </div>




                    </div>


                    <div className="row">
                        <div className="col-3">
                            <div className="mb-3 mb-md-0">
                                <label htmlFor="filter" style={{ fontWeight: "bold" }}> {t("Invoices by month")}
                                </label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className="fas fa-calendar-alt"></i>
                                        </span>
                                    </div>

                                    <select
                                        name="year"
                                        id="year"
                                        value={year}
                                        onChange={handleYearChange}
                                        className="form-control"
                                        style={{ width: "0px" }}
                                    >
                                        {yearOptions.map((yearOption) => (
                                            <option key={yearOption} value={yearOption}>
                                                {yearOption}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        name="filter"
                                        id="filter"
                                        value={filterType}
                                        onChange={handleFilterChange}
                                        className="form-control"

                                    >

                                        <option value="1">{t("January")}</option>
                                        <option value="2">{t("February")}</option>
                                        <option value="3">{t("March")}</option>
                                        <option value="4">{t("April")}</option>
                                        <option value="5">{t("May")}</option>
                                        <option value="6">{t("June")}</option>
                                        <option value="7">{t("July")}</option>
                                        <option value="8">{t("August")}</option>
                                        <option value="9">{t("September")}</option>
                                        <option value="10">{t("October")}</option>
                                        <option value="11">{t("November")}</option>
                                        <option value="12">{t("December")}</option>
                                    </select>



                                </div>
                            </div>
                        </div>

                        <div className='col-5 '>

                        </div>
                        <div className="col-4 d-flex justify-content-end">
                            <div className="">
                                {invoiceData?.status == 0 ?
                                    (
                                        <a
                                            style={{
                                                background: "#0069ff",
                                                color: "white",
                                                padding: "10px 20px",
                                                border: "none",
                                                borderRadius: "5px",
                                                cursor: "pointer"
                                            }}
                                            className="btn btn-sm btn-secondary btn_pdf mr-2 my-2 my-md-0"

                                            data-toggle="modal"
                                            aria-expanded="false"
                                            data-target="#payInvoiceModal"
                                        >
                                            {t("Payment")}!
                                        </a>

                                    ) : ""

                                }
                                <a
                                    style={{
                                        background: "gray",
                                        color: "white",
                                        padding: "10px 20px",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        marginRight: "10px"
                                    }}
                                    className="btn btn-sm btn-secondary btn_pdf mr-2 my-2 my-md-0"
                                    onClick={handlePrintPDF}
                                >
                                    {t("Download PDF file")}
                                </a>
                                {/* 
                                <a
                                    style={{
                                        background: "gray",
                                        color: "white",
                                        padding: "10px 20px",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        marginRight: "10px"
                                    }}
                                    className="btn btn-sm btn-secondary btn_pdf mr-2 my-2 my-md-0"
                                    target="_blank"
                                    href="root&action=download&invoice=57253"
                                >
                                    // <i className="material-icons icon-btn-color mr-2 size-sm notranslate">
                                    //     picture_as_pdf
                                    // </i>
                                    In hóa đơn
                                </a> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade fade2"
                    id="payInvoiceModal"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title font-weight-bold mt-2">Thanh Toán!</h4>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i className="">cancel</i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form action="" method="post" className="pb-4">
                                    <select name="paymethod" className="form-control w-100">
                                        <option value={154} selected="selected">
                                            VISA
                                        </option>
                                        {/* <option value={101}>Ví điện tử MoMo</option> */}
                                        <option value={234}>ATM</option>
                                        <option value={130}>Paypal</option>
                                        <option value={8}>QR</option>
                                        <option value={10}>Chuyển khoản ngân hàng</option>
                                        <option value={12}>Số dư</option>

                                    </select>
                                    <input
                                        type="hidden"
                                        name="security_token"
                                        defaultValue="f6f2f56f67ad04c9d0f0dab477425958"
                                    />
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="info-box">

                </div>
            </div>
            <div style={{ border: "1px solid #B7AEAE", borderRadius: "5px", marginLeft: "30px", marginRight: "30px" }}>
                <div ref={invoiceRef} id="printView" style={{ position: "relative" }}>
                    <div className="VATTEMP">
                        <div id="quantitypages" style={{ paddingLeft: 0 }}>
                            <div className="page_a4">
                                <div id="1" className="pagecurrent">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td
                                                    className="logo"
                                                    style={{ width: "150px", borderBottom: "1px solid #ccc" }}
                                                >
                                                    <img
                                                        style={{
                                                            backgroundColor: "white",
                                                            padding: "8px",
                                                            width: "100%"
                                                        }}
                                                        className="navbar-brand-full logo-header"
                                                        src={`${process.env.REACT_APP_IMAGE_LOGO}/images/logo.svg`}
                                                        alt="TIDADIGI"
                                                    />
                                                </td>
                                                <td style={{ borderBottom: "1px solid #ccc" }}>
                                                    <table style={{ width: "100%", height: "108px" }}>
                                                        <tbody>
                                                            <tr
                                                                className="vertical-align-top"
                                                                style={{ height: "18px" }}
                                                            >
                                                                <td style={{ height: "20px" }} colSpan="2">
                                                                    <strong style={{ fontWeight: "bold" }}>
                                                                        CÔNG TY TNHH TIDADIGI

                                                                    </strong>
                                                                </td>
                                                            </tr>
                                                            <tr
                                                                className="vertical-align-top"
                                                                style={{ height: "18px" }}
                                                            >
                                                                <td style={{ height: "18px" }} colSpan="2">
                                                                    {t("Tax code")}:{" "}
                                                                    <label
                                                                        className="fl-l input-name"
                                                                        style={{ fontWeight: "bold" }}
                                                                    >
                                                                        0318667211
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                            <tr
                                                                className="vertical-align-top"
                                                                style={{ height: "36px" }}
                                                            >
                                                                <td
                                                                    style={{ verticalAlign: "top", height: "44px" }}
                                                                    colSpan="2"
                                                                >
                                                                    {t("Address")}:
                                                                    <span className="fl-l input-name"> 711 An Dương Vương, Phường Bình Trị Đông, Quận Bình Tân, Thành Phố Hồ Chí Minh, Việt Nam.
                                                                    </span>
                                                                </td>

                                                            </tr>
                                                            <tr
                                                                className="vertical-align-top"
                                                                style={{ height: "18px" }}
                                                            >
                                                                <td style={{ height: "18px" }}>
                                                                    {t("Phone number")}:{" "}
                                                                    <label className="fl-l input-name">
                                                                        0918245138
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                            <tr
                                                                className="vertical-align-top"
                                                                style={{ height: "18px" }}
                                                            >
                                                                <td style={{ height: "18px" }}>
                                                                    {t("Account number")}: 63096868 tại Ngân hàng Techcombank
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className=" py-4" style={{ height: "100px" }}>
                                        <table style={{ width: "100%" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ textAlign: "left" }}>
                                                        <h2
                                                            style={{
                                                                textTransform: "uppercase",
                                                                margin: 0,
                                                                fontWeight: "bold",
                                                                fontSize: "22px",
                                                                marginBottom: 0,
                                                            }}
                                                        >
                                                            {t("Invoice")}
                                                        </h2>
                                                        <p style={{ fontStyle: "italic", margin: 0 }}>
                                                            {t("Invoice")} {invoiceData?.invoice?.invoice_number}
                                                        </p>
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        <p
                                                            style={{
                                                                fontWeight: "bold",
                                                                fontSize: "13px",
                                                                marginTop: 0,
                                                                marginBottom: 0,
                                                            }}
                                                        >
                                                            {t("Status")}:{" "}
                                                            <span
                                                                style={{
                                                                    fontSize: "15px",
                                                                    color: statusColors[1] || "#6C757D",
                                                                }}
                                                            >
                                                                {t("Paid")}
                                                            </span>

                                                        </p>

                                                        <p
                                                            style={{
                                                                fontWeight: "bold",
                                                                fontSize: "13px",
                                                                marginBottom: 0,
                                                                marginTop: 0,
                                                            }}
                                                        >
                                                            <span
                                                                className="number"
                                                                style={{ fontSize: "13px", fontStyle: "italic" }}
                                                            >
                                                                {t("From")} {startDate ? formatDate(new Date(startDate)) : ''} {t("to")} {endDate ? formatDate(new Date(endDate)) : ''}
                                                            </span>

                                                        </p>

                                                        <p
                                                            style={{
                                                                fontWeight: "bold",
                                                                fontSize: "13px",
                                                                marginBottom: 0,
                                                                marginTop: 0,
                                                            }}
                                                        >

                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <table style={{ marginTop: "5px", width: "100%", overflow: "hidden" }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ borderTop: "1px solid #ccc" }}>
                                                    <table style={{ width: "100%" }}>
                                                        <tbody>
                                                            <tr className="vertical-align-top">
                                                                <td colSpan="2">
                                                                    {t("Name buyer")}: {user?.name}                                                                </td>
                                                            </tr>
                                                            <tr className="vertical-align-top">
                                                                <td colSpan="2">
                                                                    {t("Unit name")}: {user?.name_company}                                                                </td>
                                                            </tr>
                                                            <tr className="vertical-align-top">
                                                                <td colSpan="2">
                                                                    {t("Tax code")}: {user?.taxcode}                                                                </td>
                                                            </tr>
                                                            <tr className="vertical-align-top">
                                                                <td colSpan="2">
                                                                    {t("Address")}: {user?.address}
                                                                    <label className="fl-l input-name">
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                            <tr className="vertical-align-top">
                                                                <td>
                                                                    {t("Payment method")}: {t("Balance")}
                                                                    <label className="fl-l input-name">
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className="statistics">
                                        <table
                                            className="table"
                                            style={{
                                                width: "100%",
                                                marginTop: "10px",
                                                borderCollapse: "collapse",
                                            }}
                                        >
                                            <thead>
                                                <tr style={{ height: "35px", borderBottom: "1px solid black" }}>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "20px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        STT
                                                    </th>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Products/Services")}
                                                    </th>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "60px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Unit of calculation")}
                                                    </th>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "100px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Quantity")}
                                                    </th>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "50px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Price")}
                                                    </th>

                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "100px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Tax")}
                                                    </th>
                                                    <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "100px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        {t("Amount")}
                                                    </th>
                                                    {/* <th
                                                        style={{
                                                            textAlign: "center",
                                                            width: "100px",
                                                            border: "1px solid black",
                                                        }}
                                                    >
                                                        Tiền Thuế GTGT
                                                    </th> */}

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {InvoiceItem && InvoiceItem.length > 0 ? (
                                                    <tr >
                                                        <td
                                                            align="center"
                                                            style={{ border: "1px solid black" }}
                                                        >
                                                            1
                                                        </td>
                                                        <td
                                                            style={{
                                                                border: "1px solid black",
                                                                padding: "5px",
                                                                fontSize: "13px",
                                                                whiteSpace: "normal",
                                                            }}
                                                        >
                                                            <div dangerouslySetInnerHTML={{ __html: InvoiceItem[0]?.des }} />
                                                        </td>




                                                        <td
                                                            align="center"
                                                            style={{ border: "1px solid black", textTransform: "capitalize" }}
                                                        >
                                                            {t("hour")}
                                                        </td>

                                                        <td
                                                            align="center"
                                                            style={{ border: "1px solid black" }}
                                                        >
                                                            {invoiceData?.total_hours}
                                                        </td>
                                                        <td
                                                            align="center"
                                                            style={{ border: "1px solid black" }}
                                                        >
                                                            {InvoiceItem[0]?.sub_amount && new Intl.NumberFormat('vi-VN', {}).format(InvoiceItem[0]?.sub_amount)}đ
                                                        </td>

                                                        <td
                                                            align="center"
                                                            style={{ border: "1px solid black" }}
                                                        >
                                                            {InvoiceItem[0]?.tax_rate === 10 ? "10%" : "0"}
                                                        </td>
                                                        <td
                                                            align="right"
                                                            style={{ border: "1px solid black" }}
                                                        >
                                                            {invoiceData?.total_amount.toLocaleString("vi-VN")}đ
                                                        </td>
                                                        {/* <td
                                                                align="center"
                                                                style={{ border: "1px solid black" }}
                                                            >
                                                                {item?.invoice_item?.tax?.toLocaleString("vi-VN")}
                                                            </td> */}


                                                    </tr>
                                                ) : (
                                                    <tr>
                                                        <td
                                                            colSpan="8"
                                                            align="center"
                                                            style={{ border: "1px solid black", color: "red", fontWeight: "bold" }}
                                                        >
                                                            Không có chi tiết đơn hàng tháng này.
                                                        </td>
                                                    </tr>
                                                )}
                                                <tr>
                                                    <td colSpan="6" align="right" style={{
                                                        border: "1px solid black",
                                                    }}>
                                                        <b>{t("Subtotal")}:</b>

                                                    </td>
                                                    <td
                                                        colSpan="2"
                                                        align="right"
                                                        style={{
                                                            border: "1px solid black",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {invoiceData?.total_sub_amount
                                                            ? Number(invoiceData?.total_sub_amount).toLocaleString("vi-VN")
                                                            : "0"}đ
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="6" align="right" style={{
                                                        border: "1px solid black",
                                                        fontWeight: "bold",
                                                    }}>
                                                        <b>{t("Tax")} VAT:</b>

                                                    </td>
                                                    <td
                                                        colSpan="2"
                                                        align="right"
                                                        style={{
                                                            border: "1px solid black",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {invoiceData?.total_tax
                                                            ? Number(invoiceData?.total_tax).toLocaleString("vi-VN")
                                                            : "0"}đ
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="6" align="right" style={{
                                                        border: "1px solid black",
                                                        fontWeight: "bold",
                                                    }}>
                                                        <strong>{t("Total Amount")}:</strong>

                                                    </td>
                                                    <td
                                                        colSpan="2"
                                                        align="right"
                                                        style={{
                                                            border: "1px solid black",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {invoiceData?.total_amount
                                                            ? Number(invoiceData.total_amount).toLocaleString("vi-VN")
                                                            : "0"}đ
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="clearfix">
                                            <center style={{ marginBottom: 50 }}>
                                                <table style={{ width: "100%", height: 100 }}>
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                style={{
                                                                    border: "none",
                                                                    width: 250,
                                                                    verticalAlign: "top",
                                                                    textAlign: "center"
                                                                }}
                                                            >
                                                                <p style={{ fontSize: 14, marginTop: 10, marginBottom: 0 }}>
                                                                    <strong> {t("Buyer")} </strong>
                                                                </p>
                                                                <em>({t("Signature, full name")})</em>
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "none",
                                                                    width: 250,
                                                                    verticalAlign: "top",
                                                                    textAlign: "center"
                                                                }}
                                                            >
                                                                &nbsp;
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: "none",
                                                                    width: 250,
                                                                    verticalAlign: "top",
                                                                    textAlign: "center"
                                                                }}
                                                            >
                                                                <p style={{ fontSize: 14, marginTop: 10, marginBottom: 0 }}>
                                                                    <strong> {t("Seller")} </strong>
                                                                </p>
                                                                <em>({t("Signature, seal, full name")})</em>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </center>
                                            <div>
                                                <div style={{ textAlign: "center", paddingTop: 5 }}>&nbsp;</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {invoiceData?.payment_method === "bank" && (
                    <>
                        <div className="payment-notice">
                            <p>
                                <strong>⚠ Đơn hàng chỉ hoàn thành khi Quý khách đã chuyển tiền cho TIDADIGI.</strong>
                                Quý khách vui lòng chuyển khoản theo nội dung <strong>Thanh toán đơn hàng số: {invoiceData?.invoice_number}</strong> trong nội dung thanh toán tới TIDA theo một trong các danh sách ngân hàng dưới đây.
                            </p>
                        </div>

                        <table className="bank-table">
                            <thead>
                                <tr>
                                    <th>Ngân hàng</th>
                                    <th>Logo</th>
                                    <th>Số tài khoản</th>
                                    <th>Chủ tài khoản</th>
                                    <th>Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {banks.map((bank, index) => (
                                    <tr key={index}>
                                        <td>{bank.name}</td>
                                        <td>
                                            <img
                                                src={bank.name === 'Vietcombank'
                                                    ? '/images/vietcombank-logo.png'
                                                    : 'https://upload.wikimedia.org/wikipedia/commons/7/7c/Techcombank_logo.png'}
                                                alt={`${bank.name} logo`}
                                                style={{ height: "30px" }}
                                            />
                                        </td>
                                        <td>{bank.accountNumber}</td>
                                        <td>{bank.accountName}</td>
                                        <td>
                                            <button
                                                style={{
                                                    backgroundColor: colorButton,
                                                    color: textColor,
                                                    border: "none",
                                                    borderRadius: "5px",
                                                    cursor: isDisabled ? "not-allowed" : "pointer",
                                                    opacity: isDisabled ? 0.6 : 1,
                                                }}
                                                onClick={handleConfirmBank}
                                                disabled={isDisabled}
                                            >
                                                Đã chuyển khoản
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>
                )}
            </div>
        </>

    );
};

export default InvoiceDetailCSHP;
